export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoFOODSERVICE.712751c1.svg";